/* eslint import/prefer-default-export: "off" */
import {
  CloudTypeEnum,
  AccountInfo
} from '@src/endpoints/services/base.service'
import { getCloudTypeById } from './accounts'

function getSeparatorByAccountId(
  id: string,
  accountInfo: AccountInfo[]
): string {
  const accountType: CloudTypeEnum | '' = getCloudTypeById(id, accountInfo)
  if (
    [CloudTypeEnum.AZURE, CloudTypeEnum.IDP_AZURE_AD, ''].includes(accountType)
  )
    return '/'
  return ':'
}

function getNameAndType(typeName: string, separator = ':', type?: string) {
  const pos: number = (typeName || '').indexOf(separator)
  if (pos >= 0)
    return {
      type: typeName.slice(0, pos).toUpperCase(),
      name: typeName.slice(pos + 1)
    }

  return { name: typeName, type }
}

export { getNameAndType, getSeparatorByAccountId }
